import React from "react";

// Discovery filter chip — extracted from pages/Collectives.jsx (Phase 15
// component split); behaviour unchanged.
export function Chip({ active, disabled, onClick, testId, children, title }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={
        "px-3.5 h-8 rounded-full text-xs font-medium border transition-all whitespace-nowrap " +
        (disabled
          ? "border-neutral-200 text-neutral-400 cursor-not-allowed bg-neutral-50"
          : active
            ? "border-forest bg-forest text-white shadow-sm"
            : "border-neutral-300 text-forest hover:border-forest/60 bg-white")
      }
    >
      {children}
    </button>
  );
}

